import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { OfficeLocationField } from 'fields';
import { useField } from 'formik';
import { useLocalStorage } from 'hooks/useLocalStorage';
import useFieldOfficeLocation from 'hooks/useFieldOfficeLocation';

export default function OfficeLocation() {
  const { t } = useTranslation('CreateOrder');

  const [{ value: selectedOfficeLocation }, , { setValue }] = useField('officeLocation');
  const [{ value: products }, , { setValue: setProducts }] = useField('products');

  const { officeLocationChangeDialog } = useFieldOfficeLocation('CreateOrder');

  const [, updateOfficeLocation] = useLocalStorage('officeLocation');

  const handleChange = useCallback(
    async (value, prevValue) => {
      const confirmed = await officeLocationChangeDialog(value, products?.length || 0);

      if (value && products && products.length && !confirmed) {
        await setValue(prevValue);
        return;
      }
      updateOfficeLocation(value);
      await setProducts([]);
    },
    [updateOfficeLocation, products, setProducts, setValue, officeLocationChangeDialog],
  );

  const resetValue = useCallback(async () => {
    await setValue('');
    await setProducts([]);
  }, [setValue, setProducts]);

  return (
    <OfficeLocationField
      name="officeLocation"
      label={t('CustomerDetails.labels.officeLocation')}
      placeholder={t('CustomerDetails.placeholders.officeLocation')}
      onChange={handleChange}
      resetValue={resetValue}
      selectedOfficeLocation={selectedOfficeLocation}
    />
  );
}
